import {
  PopupOverlay,
  PopupContainer,
  FADE_DURATION,
  PopupInner
} from './Popup.styles';

import { DELTA_UPDATE } from '@CS/utils/Number';
import { forwardRef, useState, useEffect } from 'react';
import type { ForwardedRef, CSSProperties } from 'react';
import CloseButton from '@CS/assets/Vector/close.svg?component';

type Children<Child> = Child | Child[];
type Child = JSX.Element | string;

export type PopupProps = {
  customStyle?: CSSProperties;
  children?: Children<Child>;

  opacity?: number | string;
  width?: number | string;

  onClose?: () => void;
  fullScreen?: boolean;
  background?: string;

  hideClose?: boolean;
  overlay?: boolean;
  close?: boolean;
};

export const Popup = forwardRef(
  (
    {
      onClose = () => void 0,
      background = '#fff',

      fullScreen = false,
      hideClose = true,

      overlay = true,
      opacity = 0.9,
      close = false,

      width = 87.2,
      customStyle,
      children
    }: PopupProps,
    ref: ForwardedRef<HTMLDialogElement>
  ) => {
    const [visible, setVisible] = useState(close);

    const onPopupClose = () => {
      setTimeout(onClose, FADE_DURATION);
      setVisible(false);
    };

    useEffect(() => {
      close && onPopupClose();
    }, [close]);

    useEffect(() => {
      setTimeout(() => setVisible(true), DELTA_UPDATE);
    }, []);

    return (
      <PopupOverlay visible={visible} overlay={overlay} opacity={opacity}>
        <PopupContainer
          fullScreen={fullScreen}
          style={customStyle}
          width={width}
          ref={ref}
        >
          <PopupInner background={background}>
            {!hideClose && <CloseButton onClick={onPopupClose} />}
            {children}
          </PopupInner>
        </PopupContainer>
      </PopupOverlay>
    );
  }
);
